import React from 'react';
import Offers from './Offers';
import ParentLayout from './ParentLayout';

export default function Layout(props) {
  return (
    <ParentLayout title="Offers">
      {function(params) {
        return (
          <>
            <Offers params={params} />
          </>
        );
      }}
    </ParentLayout>
  );
}
